module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sortedVersions.length > 0) ? _c('div', {
    staticClass: "task-overview"
  }, [_c('div', {
    staticClass: "to-versions"
  }, [_c('DDropdown', {
    attrs: {
      "isShowDots": false
    }
  }, [_c('div', {
    staticClass: "d-drop-box",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.versions')) + " "), _c('span', {
    staticClass: "icon-arrow-down52"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.sortedVersions), function(version) {
    return _c('li', {
      key: version.id,
      on: {
        "click": function($event) {
          return _vm.selectVersion(version)
        }
      }
    }, [_vm._v("\n          " + _vm._s(version.vTitle) + "\n        ")])
  }), 0)])], 1), _vm._v(" "), (_vm.activeVersion) ? _c('DModal', {
    attrs: {
      "showClose": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        _vm.activeVersion = null
      }
    }
  }, [_c('div', {
    staticClass: "to-versions__modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "to-versions__modal__header"
  }, [_c('div', {
    staticClass: "to-versions__modal__header__left pad-1-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeVersionId),
      expression: "activeVersionId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeVersionId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectVersionFromId(_vm.activeVersionId)
      }]
    }
  }, _vm._l((_vm.sortedVersions), function(version) {
    return _c('option', {
      key: version.id,
      domProps: {
        "value": version.id
      }
    }, [_vm._v("\n            " + _vm._s(version.vTitle) + "\n          ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "pad-1-left"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.saved_message')) + ": " + _vm._s(_vm.versionDateFormatted) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "to-versions__modal__header__right"
  }, [(_vm.isUserSchoolAdmin) ? _c('DDropdown', {
    attrs: {
      "isBottomStart": false
    }
  }, [_c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    staticClass: "d-item-warning",
    on: {
      "click": _vm.setWarningToDelete
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.task_versions.delete_message')) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        _vm.activeVersion = null
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "to-versions__modal__body"
  }, [_c('TaskOverviewUser', {
    attrs: {
      "user": _vm.user,
      "version": _vm.activeVersion
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isDeleteWarningActive) ? _c('DModal', {
    staticStyle: {
      "z-index": "999999999"
    },
    attrs: {
      "appendToBody": true,
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-warning text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-warning__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": function($event) {
        _vm.isDeleteWarningActive = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__body"
  }, [_c('svg', {
    staticClass: "tw-icon tw-icon--red",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.confirm_delete_message')) + " " + _vm._s(_vm.activeVersion.vTitle) + "?")]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_versions.delete_warning_message')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isDeleteWarningActive = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--warning bttn-danger bttn-primary--small",
    class: [{
      'bttn--loading': _vm.isSaving
    }],
    on: {
      "click": _vm.deleteVersion
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n      ")])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51914942!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/TaskOverview/TaskOverview.vue
// module id = 1597
// module chunks = 1